<template>
  <view>
    <cube-button bindclick="showPicker">slot-Picker</cube-button>
    <cube-time-picker-modal
      wx:ref="picker"
      title="标题"
      min="{{min}}"
      max="{{max}}"
      minuteStep="{{minuteStep}}"
    >
      <view slot="header" class="demo-slot-header-wrapper">
        <image class="demo-slot-header" src="https://ut-static.udache.com/webx/mpx-cube-ui/1GyZ1gVbkoNIDOtGNwyUh.jpg" style="background-size: 100%"></image>
      </view>
      <view slot="footer" class="demo-slot-footer" bindtap="clickCustomBtn">时间不在范围内</view>
    </cube-time-picker-modal>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    data: {
      min: Date.now() - 1 * 60 * 60 * 1000,
      max: Date.now() + 3 * 24 * 60 * 60 * 1000,
      minuteStep: {
        rule: 'ceil',
        step: 15
      }
    },
    methods: {
      showPicker() {
        this.confirmParams = '{ /* selectedIndex, selectedVal, selectedText */ }'
        this.valueChangeParams = '{ /* selectedIndex, selectedVal, selectedText */ }'
        this.$refs.picker.show()
      },
      clickCustomBtn() {
        this.$refs.picker.hide()
      }
    }
  })
</script>

<style lang="stylus" scoped>
.demo-slot-header-wrapper
  margin-bottom: 10px
  font-size: 0px
.demo-slot-header
  width 100%
  height 170px
.demo-slot-footer
  margin-top 15px
  text-align center
  font-size 16px
  color #757575
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-time-picker-modal": "@mpxjs/mpx-cube-ui/src/components/time-picker-modal/index"
    }
  }
</script>
